/**
 * Application entry point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import {RouterProvider} from 'react-router-dom';
import {Analytics} from '@vercel/analytics/react';
import {router} from './routes';
import {ErrorBoundary} from './components/ErrorBoundary';
import {AuthProvider} from './components/auth/AuthProvider';
import {ThemeProvider} from './components/layout/ThemeProvider';
import './index.css';

// Initialize Firebase after DOM is ready to prevent Electron crashes
// Wrap in try-catch to prevent crashes from propagating
try {
  // Use dynamic import to defer execution until after module evaluation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      import('./config/firebase').catch((error) => {
        console.error('Failed to load Firebase config:', error);
      });
    });
  } else {
    // DOM already ready, import immediately
    import('./config/firebase').catch((error) => {
      console.error('Failed to load Firebase config:', error);
    });
  }
} catch (error) {
  console.error('Failed to initialize Firebase:', error);
}

// Global error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  // Prevent default browser error handling
  event.preventDefault();
  // Log to console for debugging
  if (event.reason instanceof Error) {
    console.error('Error details:', event.reason.message, event.reason.stack);
  }
});

// Global error handler for uncaught errors
window.addEventListener('error', (event) => {
  console.error('Uncaught error:', event.error);
  // Log to console for debugging
  if (event.error instanceof Error) {
    console.error('Error details:', event.error.message, event.error.stack);
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <RouterProvider router={router} />
          <Analytics />
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
